import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { SystemApi } from "features/brm";

/**
 * Sets the category of an Datatype
 *
 * @param {string} dataTypeId - uuid of the dataType
 * @param {string} category - new category of the dataType
 */
export const setDataTypeCategory = ({ dataTypeId, category }) => {
  return Brm.dataTypeApi.setDataTypeCategory(dataTypeId, { body: category });
};

/**
 * Custom hook to change the category of an existing datatype
 *
 * @param {object} config - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetDataTypeCategory = ({ projectId, config = {} } = {}) => {
  const queryClient = ReactQuery.useQueryClient();

  return ReactQuery.useMutation({
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.project(projectId));
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.dataType(variables.dataTypeId));
    },
    ...config,
    mutationFn: setDataTypeCategory,
  });
};
